import { Injectable } from '@angular/core'
import { Country } from '@spartacus/core'
import { MbCartMigrationContext } from '../../models'

@Injectable({
  providedIn: 'root',
})
export abstract class MbCartMigrationFacade {
  /**
   * Migrate cart to new baseSite
   */
  abstract migrateCart (cartId: string, selectedCountry?: Country, isLoginProcess?: boolean): void

  abstract getCartMigrationInfo(selectedCountry: string, cartId: string, isLoginProcess: boolean): MbCartMigrationContext | undefined
}
